export default __webpack_public_path__ + "static/media/large.6eb62fda.jpg";